<script setup lang="ts">
import { computed } from 'vue';
import type { SpeechBubbleProps } from './speech-bubble';

const props = withDefaults(defineProps<SpeechBubbleProps>(), {
  variant: 'default',
});

const isSent = computed(() => props.mode === 'sent');
</script>

<template>
  <div class="flex w-full" :class="isSent ? 'justify-end' : 'justify-start'">
    <div
      class="w-fit text-sm leading-relaxed break-words whitespace-pre-wrap"
      :class="[
        props.variant === 'minimal' && !isSent
          ? 'py-2'
          : 'rounded-2xl px-4 py-2',
        isSent
          ? props.variant === 'minimal'
            ? 'max-w-[95%] rounded-br-sm bg-slate-100 text-slate-800'
            : 'bg-primary-500 max-w-[95%] rounded-br-sm text-white'
          : props.variant === 'minimal'
            ? 'max-w-full text-slate-800'
            : 'max-w-[95%] rounded-bl-sm bg-neutral-100 text-neutral-900',
      ]"
    >
      <slot />
    </div>
  </div>
</template>
